import { Channel, ChannelFilters, StreamChat } from 'stream-chat';

import { ChannelMembershipType } from 'src/store/messages/types';

export const baseChannelsFilter: ChannelFilters = {
  type: 'messaging',
  disabled: false,
};

export const getMessagesChannels = async (
  chatClient: StreamChat,
  filter: any,
) => {
  const channels = await chatClient.queryChannels(filter, {}, {});
  return channels;
};

export const getChannelsWithUser = async (
  userData: { memberId: string; companyId: string | null },
  getstreamClient: StreamChat,
) => {
  const companyFilter = userData.companyId
    ? { companyID: userData.companyId }
    : {};
  const channelFilter = {
    ...baseChannelsFilter,
    members: {
      $in: [userData.memberId],
    },
    ...companyFilter,
  };
  return getstreamClient.queryChannels(channelFilter as ChannelFilters, {}, {});
};

export const getCompanyChannel = async (
  companyID: string,
  getstreamClient: StreamChat,
) => {
  const channelFilter = {
    ...baseChannelsFilter,
    companyID: `${companyID}`,
    membershipType: 'company',
  };
  const channels: Channel[] = await getstreamClient.queryChannels(
    channelFilter as ChannelFilters,
    {},
    {},
  );
  return channels;
};

export const findMessageChannelsWithSameComposition = async (
  chatClient: StreamChat,
  members: string[],
  membershipType: ChannelMembershipType,
  companyID: string | undefined,
) => {
  const predicate = members.map((memberId: string) => ({
    members: {
      $in: [memberId],
    },
    ...(companyID ? { companyID: { $eq: companyID } } : {}),
  }));
  const filter = {
    ...baseChannelsFilter,
    membershipType,
    $and: predicate,
  };

  return getMessagesChannels(chatClient, filter);
};
